// Testimonial Carousel
const testimonials = document.querySelectorAll('.testimonials--carousel');
testimonials.forEach(testimonial => {
  const testimonialCarousel = new Siema({
    selector: testimonial.querySelector('.testimonials__carousel__wrapper'),
    loop: true
  });
  testimonial.querySelector('.testimonials__nav--prev button').addEventListener('click', () => testimonialCarousel.prev());
  testimonial.querySelector('.testimonials__nav--next button').addEventListener('click', () => testimonialCarousel.next());
});

// Carousels
const carousels = document.querySelectorAll('.carousel');
carousels.forEach(carousel => {
  const carouselSiema = new Siema({
    selector: carousel.querySelector('.carousel__wrapper'),
    loop: true,
    onInit: function () {
      insertDotNavigation(this);
      updateActiveDot(this);
    },
    onChange: function () {
      updateActiveDot(this);
    }
  });
  carousel.querySelector('.carousel__nav__button--prev').addEventListener('click', () => carouselSiema.prev());
  carousel.querySelector('.carousel__nav__button--next').addEventListener('click', () => carouselSiema.next());
});

// Carousels -  no dots
const carousels_noDot = document.querySelectorAll('.carousel-no-dot');

carousels_noDot.forEach(carousel => {
  var slides = carousel.querySelectorAll('.masthead');
  if (slides.length > 1) {
    if (!carousel.classList.contains("disabled")) {
      const carouselSiema = new Siema({
        selector: carousel.querySelector('.carousel__wrapper'),
        duration: 700,
        easing: 'ease-in-out',
        loop: true,
        onInit: function () {
          // Siema clones the first/last slides for loop mode — demote any cloned h1 to h2
          // so the page never has more than one h1 in the DOM.
          const wrapper = carousel.querySelector('.carousel__wrapper');
          wrapper.querySelectorAll('.masthead').forEach(slide => {
            if (slide !== this.innerElements[0]) {
              slide.querySelectorAll('h1').forEach(h1 => {
                const h2 = document.createElement('h2');
                h2.className = h1.className || 'h1';
                if (!h2.classList.contains('h1')) { h2.classList.add('h1'); }
                h2.innerHTML = h1.innerHTML;
                h1.parentNode.replaceChild(h2, h1);
              });
            }
          });
        }
      });

      let autoplay = setInterval(() => carouselSiema.next(), 6500);

      const resetAutoplay = () => {
        clearInterval(autoplay);
        autoplay = setInterval(() => carouselSiema.next(), 6500);
      };

      carousel.querySelector('.carousel__nav__button--prev').addEventListener('click', () => { carouselSiema.prev(); resetAutoplay(); });
      carousel.querySelector('.carousel__nav__button--next').addEventListener('click', () => { carouselSiema.next(); resetAutoplay(); });
    }
  } else {
    var carNav = carousel.querySelector('.carousel__nav');
    if (carNav) {
      carNav.classList.add('hidden');
    }
  }
});

// Carousels -  3 cards per view
const carousels_3Col = document.querySelectorAll('.carousel__3-col');
carousels_3Col.forEach(carousel => {
  if (!carousel.classList.contains("disabled")) {
    var loop = true;
    if (carousel.classList.contains("number_txt-carousel")) {
      loop = false;
    }
    var perPage = 0;

    function calculatePerPage() {
      perPage = 0;
      if (window.innerWidth >= 768) {
        perPage = 2;
      }
      if (window.innerWidth >= 1024) {
        perPage = 3;
      }
    }

    var buttonPrev = carousel.querySelector('.carousel__nav__button--prev');
    var buttonNext = carousel.querySelector('.carousel__nav__button--next');
    const carouselSiema = new Siema({
      selector: carousel.querySelector('.carousel__wrapper'),
      perPage: {
        768: 2,
        1024: 3
      },
      loop: loop,
      onInit: () => {
        buttonPrev.disabled = true;
      },
      onChange: () => {
        index = carouselSiema.currentSlide;
        buttonPrev.disabled = (0 === index);
        buttonNext.disabled = (
          index + 1 === carouselSiema.innerElements.length ||
          index + perPage >= carouselSiema.innerElements.length
        );
      }
    });
    if (buttonPrev !== null) {
      buttonPrev.addEventListener('click', () => carouselSiema.prev());
    }
    if (buttonNext !== null) {
      buttonNext.addEventListener('click', () => carouselSiema.next());
    }

    calculatePerPage();
    var timeId = null;
    window.addEventListener('resize', () => {

      // It clears the previous timeout
      clearTimeout(timeId);

      // It creates a new timeout to execute the function
      timeId = setTimeout(calculatePerPage, 500);
    });


  }
});

// Carousels -  2 cards per view
const carousels_2Col = document.querySelectorAll('.carousel__2-col');
if (carousels_2Col.length > 0) {
  var carousels2ColExists = [];
  carousels_2Col.forEach(carousel => {
      carousels2ColExists[carousel.id] = false;
    }
  );

  function build_carousels_2Col() {
    carousels_2Col.forEach(carousel => {
      if (!carousels2ColExists[carousel.id]) {
        if (!carousel.classList.contains("disabled")) {
          if (window.innerWidth >= 768) {
            var buttonPrev = carousel.querySelector('.carousel__nav__button--prev');
            var buttonNext = carousel.querySelector('.carousel__nav__button--next');
            const carouselSiema = new Siema({
              selector: carousel.querySelector('.carousel__wrapper'),
              perPage: {
                768: 2
              },
              loop: false,
              onInit: () => {
                buttonPrev.disabled = true;
              },
              onChange: () => {
                index = carouselSiema.currentSlide;
                buttonPrev.disabled = (0 === index);
                buttonNext.disabled = (
                  index + 1 === carouselSiema.innerElements.length ||
                  index + 2 >= carouselSiema.innerElements.length
                );
              }
            });


            if (buttonPrev !== null) {
              buttonPrev.addEventListener('click', () => carouselSiema.prev());
            }
            if (buttonNext !== null) {
              buttonNext.addEventListener('click', () => carouselSiema.next());
            }
            carousels2ColExists[carousel.id] = true;
          }
        }
      } else {
        if (window.innerWidth < 768) {
          // reload page if the carousel exists and on mobile.
          // THIS DOES NOT WORK
          // carousels_2Col.destroy(false);
          location.reload();
        }
      }
    });
  }

  build_carousels_2Col();
  var timeId = null;
  window.addEventListener('resize', () => {
    // It clears the previous timeout
    clearTimeout(timeId);
    // It creates a new timeout to execute the function
    timeId = setTimeout(build_carousels_2Col, 1000);
  });
}


// Carousels -  2 cards per view
const carousels_mobile = document.querySelectorAll('.carousel-mobile');
if (carousels_mobile.length > 0) {
  var carouselsMobileExists = false;

  function build_carousels_mobile() {
    if (!carouselsMobileExists) {
      carousels_mobile.forEach(carousel => {
        if (!carousel.classList.contains("disabled")) {
          if (window.innerWidth < 768) {
            const carouselSiema = new Siema({
              selector: carousel.querySelector('.cards__wrapper'),
              loop: true
            });

            var buttonPrev = carousel.querySelector('.carousel__nav__button--prev');
            var buttonNext = carousel.querySelector('.carousel__nav__button--next');

            if (buttonPrev !== null) {
              buttonPrev.addEventListener('click', () => carouselSiema.prev());
            }
            if (buttonNext !== null) {
              buttonNext.addEventListener('click', () => carouselSiema.next());
            }
            carouselsMobileExists = true;
          }
        }
      });
    } else {
      if (window.innerWidth > 768) {
        // reload page if the carousel exists and on mobile.
        // THIS DOES NOT WORK
        // carouselSiema.destroy(false);
        location.reload();
      }
    }
  }

  build_carousels_mobile();
  var timeId = null;
  window.addEventListener('resize', () => {

    // It clears the previous timeout
    clearTimeout(timeId);

    // It creates a new timeout to execute the function
    timeId = setTimeout(build_carousels_mobile, 500);
  });
}


function insertDotNavigation(carousel) {
  // Create the dots navigation element
  carousel.dots = document.createElement('div');
  carousel.dots.classList.add('carousel__nav__dots');
  // Add the dot buttons
  for (let i = 0; i < carousel.innerElements.length; i++) {
    const dot = document.createElement('button');
    dot.setAttribute('aria-label', 'Go to carousel item ' + (i + 1));
    dot.addEventListener('click', () => {
      carousel.goTo(i);
    })
    carousel.dots.appendChild(dot);
  }
  // Add the dots navigation element to DOM
  carousel.selector.previousElementSibling.insertBefore(carousel.dots, null);
};

function updateActiveDot(carousel) {
  console.log(carousel.dots);
  for (let i = 0; i < carousel.dots.querySelectorAll('button').length; i++) {
    // if current dot matches currentSlide prop, add a class to it, remove otherwise
    const addOrRemove = carousel.currentSlide === i ? 'add' : 'remove';
    carousel.dots.querySelectorAll('button')[i].classList[addOrRemove]('active');
  }
}
